<!--代办处奖金查询-->
<template>
  <div class="AgentBonusQuery">
    <app-breadcrumb/>
    <div class="page-container account">
        <el-form size="small" :inline="true" :model="listQuery">
          <!-- 时间-->
          <el-form-item :label="$t('label.time')">
            <!-- 时间开始 -->
            <el-date-picker
                    v-model="listQuery.formMonth"
                    type="month"
                    value-format="yyyyMM"
                    placeholder="选择月">
            </el-date-picker>
            &nbsp;&nbsp; - &nbsp;&nbsp;
            <!-- 时间结束 -->
            <el-date-picker
                    v-model="listQuery.toMonth"
                    type="month"
                    value-format="yyyyMM"
                    placeholder="选择月">
            </el-date-picker>
          </el-form-item>
        <el-button type="primary"  :loading="btnLoading" size="small" plain icon="el-icon-search" @click="handleFilter">{{ $t('operation.button.search')}}</el-button>
      </el-form>
      <el-table
          v-loading="tableLoading"
          :data="list"
          border
          fit
          size="mini"
          stripe
          style="width: 100%"
      >
        <!-- 开始期数 -->
        <el-table-column :label="$t('Start.Period')" align="center" prop="wStartWeek" />
<!--        结束期次-->
        <el-table-column :label="$t('End.Period')" align="center" prop="wEndWeek" />
<!--        月份-->
        <el-table-column :label="$t('printReturnList.month')" align="center" prop="wMonth" />
        <!-- 代办费 -->
        <el-table-column :label="$t('bonus.agentFee')" align="center" prop="bonusAgent" />
       <div v-if="companyCode === 'IN'">
         <!-- 开始期数 -->
         <el-table-column :label="$t('Start.Period')" align="center" prop="wStartWeek" />
         <!--        结束期次-->
         <el-table-column :label="$t('End.Period')" align="center" prop="wEndWeek" />
         <!--        月份-->
         <el-table-column :label="$t('printReturnList.month')" align="center" prop="wMonth" />
         <!-- 代办费 -->
         <el-table-column :label="$t('bonus.agentFee')" align="center" prop="bonusAgent" />
       </div>
      </el-table>
      <pagination
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { mapGetters } from "vuex"
import {bdBonusHisAgents} from "@/api/agent";

export default {
  name: 'AgentBonusQuery',
  components: { Pagination },
  data() {
    return {
      list: [],
      btnLoading: false,
      tableLoading: false,
      wWeekList: [],
      listQuery: {
        page: 1,
        limit: 15,
      },
      total: 0
    }
  },
  computed: {
    ...mapGetters([
      'companyCode',
    ])
  },
  methods: {
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    getList() {
      this.btnLoading = true
      this.tableLoading = true
      bdBonusHisAgents({ ...this.listQuery }).then(res => {
        this.list = res.data.records
        this.total = +res.data.total || 0
        this.btnLoading = false
        this.tableLoading = false
      }).catch(() => {
        this.btnLoading = false
        this.tableLoading = false
      })
    }
  }
}
</script>

<style scoped>

</style>